import logger from '../common/safe-log';

const module = 'EverflowTracker';
const buildEfOrder = (order) => {
  try {
    const efOrder = {
      oid: order?.id,
      advid: order?.name,
      amt: order?.total_price,
      bs: order?.shipping_address?.province,
      bc: order?.shipping_address?.country,
      cc: order?.discount?.code,
      items: []
    };
    const lineItems = order.line_items.map(li => {
      let item = {
        ps: li.sku,
        p: li.price,
        qty: li.quantity,
      };
      return item;
    });
    efOrder.items = lineItems;
    return efOrder;
  } catch (e) {
    logger.error('buildEfOrder Failed', e, { module });
    return {};
  }
};

const getAdv3 = (lineItems) => {
  try {
    let adv3 = '';
    lineItems.forEach(lineItem => {
      const productId = lineItem.product_id;
      const product = window?.gu_remote_data?.productData.find(x => x.id == productId);
      let tags = product?.tags;
      tags.forEach(tag => {
        if (tag.indexOf('adv3:') != -1) {
          adv3 = tag.split(':')[1].trim();
        }
      });
    });
    return adv3;
  } catch (e) {
    logger.error('getAdv3 Failed', e, { module });
    return '';
  }
};


const EverflowEventMappings = {
  'Splash Page': {
    advertiser_id: window?.site_vars?.advertiser_id,
    event_id: window?.site_vars?.vsl_landing_event
  },
  'Presell Page': {
    advertiser_id: window?.site_vars?.advertiser_id,
    event_id: window?.site_vars?.presell_landing_event
  },
  'Landing Page': {
    advertiser_id: window?.site_vars?.advertiser_id,
    event_id: window?.site_vars?.landing_page_event
  },
  'Splash Page Start': {
    advertiser_id: window?.site_vars?.advertiser_id,
    event_id: window?.site_vars?.vsl_landing_start_event
  },
  'Presell Page Start': {
    advertiser_id: window?.site_vars?.advertiser_id,
    event_id: window?.site_vars?.presell_landing_start_event
  },
  'Landing Page Start': {
    advertiser_id: window?.site_vars?.advertiser_id,
    event_id: window?.site_vars?.landing_page_start_event
  },
  'Select Bundle': {
    advertiser_id: window?.site_vars?.advertiser_id,
    event_id: window?.site_vars?.add_to_cart_event
  },
  'View Inline Upsell': {
    advertiser_id: window?.site_vars?.advertiser_id,
    event_id: window?.site_vars?.view_inline_upsell
  },
  'View Pop Sale': {
    advertiser_id: window?.site_vars?.advertiser_id,
    event_id: window?.site_vars?.view_popup_upsell
  },
  'Initiate Checkout': {
    advertiser_id: window?.site_vars?.advertiser_id,
    event_id: window?.site_vars?.initiate_checkout_event
  },
  'Shipping Info': {
    advertiser_id: window?.site_vars?.advertiser_id,
    event_id: window?.site_vars?.shipping_info_event
  },
  'Order Conversion': {
  }
};

const EverflowTracker = {
  trackEvent: (eventProperties) => {
    try {
      const eventName = eventProperties.eventName;
      if (eventName == 'Order Conversion') {
        EverflowTracker.trackConversion();
      } else if (EverflowEventMappings?.[eventName]) {
        const event = EverflowEventMappings[eventName];
        if((typeof event.event_id  !== 'undefined' && event.event_id) && event.event_id !== '0'){
          EverflowTracker.track(event.advertiser_id, event.event_id);
        }
      }
    } catch (e) {
      logger.error('trackEvent Failed', e, { module });
    }
  },
  trackConversion: () => {
    try {
      const order = window.gu_payments.order.order;
      if (order) {
        if (window.EF) {
          let efconv = {
            aid: window.site_vars.advertiser_id,
            amount: order.total_price,
            nid: 373,
            adv1: order.name,
            adv3: getAdv3(order.line_items),
            order: buildEfOrder(order)
          };

          if (window.gu_qs && window.gu_qs['req_id']) {
            efconv.transaction_id = window.gu_qs['req_id'];
          }
          if (window.gu_qs && window.gu_qs['listicle_origin']) {
            efconv.adv5 = window.gu_qs['listicle_origin'];
          }
          window.EF.conversion(efconv).then((conversion) => {
            logger.info('Everflow Conversion', { everflowConversionResponse: conversion });
          }).catch((error) => {
            logger.error('Everflow Conversion error', { everflowConversionResponse: error });
          });
        } else {
          let transactionid = '';
          if (window.gu_qs && window.gu_qs['req_id']) {
            transactionid += window.gu_qs['req_id'];
          }

          let listicleOrigin = ''
          if (window.gu_qs && window.gu_qs['listicle_origin']) {
            listicleOrigin += window.gu_qs['listicle_origin'];
          }

          let script = document.createElement('iframe');
          script.width = 1;
          script.height = 1;
          script.frameBorder = 0;
          script.src = 'https://www.gu-ecom.com/?nid=373&advid=' + window.site_vars.advertiser_id
          + '&transaction_id=' + transactionid
          + '&adv5=' + listicleOrigin
          document.getElementsByTagName('script')[0].appendChild(script);
        }
      }
    } catch (e) {
      logger.error('trackConversion Failed', e, { module });
    }
  },
  track: (advertiser, adv_event) => {
    try {
      if (window.EF) {
        let efpixel = {
          aid: advertiser,
          adv_event_id: adv_event,
          nid: 373
        };
        if (window.gu_qs && window.gu_qs['req_id']) {
          efpixel.transaction_id = window.gu_qs['req_id'];
        }
        window.EF.conversion(efpixel).then((conversion) => {
          logger.info('Everflow Event', { everflowConversionResponse: conversion });
        }).catch((error) => {
          logger.error('Everflow Event error', { everflowConversionResponse: error });
        });
      } else {
        let transactionid = '';
        if (window.gu_qs && window.gu_qs['req_id']) {
          transactionid += window.gu_qs['req_id'];
        }
        let script = document.createElement('iframe');
        script.width = 1;
        script.height = 1;
        script.frameBorder = 0;
        script.src = 'https://www.gu-ecom.com/?nid=373&advid=' + advertiser + '&adv_event_id=' + adv_event + '&transaction_id=' + transactionid;
        document.getElementsByTagName('script')[0].appendChild(script);
      }
    } catch (e) {
      logger.error('track Failed', e, { module });
    }
  },
};
export default EverflowTracker;